export default {"src":"/_next/static/media/payment.5ce37b9b.svg","height":54,"width":51};